import { ORIGIN_TO_SLUG_MAP } from "@/lib/constants/common";

function getHomepageSlugByOrigin(origin) {
  if (!origin) return "alhome-web-home"; // default fallback

  const normalizedOrigin = origin.toLowerCase();

  return ORIGIN_TO_SLUG_MAP[normalizedOrigin] || "alhome-web-home";
}

export default getHomepageSlugByOrigin;
